import { useAppContext } from '@contexts/app';
import { useAccess } from '@hooks/access';
import { useMediaQuery } from '@hooks/useMediaQuery';
import { localStore } from '@utils/localStore';

export const useBottomNavEnabled = () => {
  const { isLogged, admin } = useAppContext();
  const access = useAccess();
  const isDesktop = useMediaQuery('(min-width: 1024px)');
  const loggedIn =
    isLogged ||
    admin.isLogged ||
    Boolean(localStore.getItem('app-user')) ||
    Boolean(localStore.getItem('app-admin'));

  return loggedIn && !isDesktop && !access.fieldUser;
};
